// extracted by mini-css-extract-plugin
var _1 = "TemplateIcon-module__animatedBackground--_oERj";
var _2 = "TemplateIcon-module__icon--MU3jb";
export { _1 as "animatedBackground", _2 as "icon" }
